import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { useHtzConfirmationDeleteMutation } from "@/services/backend/htz/confirmations/api/confirmation-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useNavigate, useParams } from "react-router";

export function DeleteConfirmationDialog({
  confirmationId,
}: {
  confirmationId: string;
}) {
  const [open, setOpen] = useState(false);
  const [doDelete, { isLoading, error, isSuccess, reset }] =
    useHtzConfirmationDeleteMutation();

  const navigate = useNavigate();
  const { processId } = useParams();

  if (isSuccess) {
    setOpen(false);
    reset();
    navigate(`/processes/htz/${processId}/confirmations`);
  }

  const onClick = () => {
    if (isLoading) {
      return;
    }

    doDelete({ id: confirmationId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">
          <Trash2 className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("Auftragsbestätugung wirklich löschen?")}
          </DialogTitle>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onClick}>
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
